import api from '@flatfile/api';
import FlatfileListener from '@flatfile/listener';
import { FlatfileRecord, recordHook } from '@flatfile/plugin-record-hook';
import { validateRecord } from './validation';
import { processTenantData } from './dataMapping';
import { TenantCSVType } from '../types';

export const listener =
  (
    handleBulkAdd: (tenants: TenantCSVType[]) => void,
    closePortal: () => void
  ) =>
  (listener: FlatfileListener) => {
    listener.use(
      recordHook('tenants', (record: FlatfileRecord) => {
        return validateRecord(record);
      })
    );

    listener.on(
      'job:ready',
      { job: 'workbook:submitActionFg' },
      async ({
        context: { jobId, workbookId },
      }: {
        context: { jobId: string; workbookId: string };
      }) => {
        try {
          const workbook = await api.workbooks.get(workbookId);
          const sheet = workbook.data?.sheets?.[0];

          if (!sheet) {
            throw new Error('No sheets found in workbook');
          }

          const sheetData = await api.records.get(sheet.id);

          const tenants: TenantCSVType[] = processTenantData(
            sheet,
            sheetData.data.records
          );

          handleBulkAdd(tenants);

          await api.jobs.complete(jobId, {
            outcome: {
              acknowledge: true,
              message: 'Tenants imported successfully.',
              next: {
                type: 'wait',
              },
            },
          });
        } catch (error: unknown) {
          console.error('Error:', error instanceof Error ? error.stack : error);

          await api.jobs.fail(jobId, {
            outcome: {
              message: 'This job encountered an error.',
            },
          });
        }
      }
    );

    listener.on('job:completed', { job: 'workbook:submitActionFg' }, () => {
      closePortal();
    });
  };
